import '@styles/components/1+xMunicipalRoadBridge.less';
import AppFooter from '@components/app/appFooter';
import history from '@tools/history';

const MunicipalRoadBridge = () => {
  let BASList = [
    { name: '基础建模', desc: 'MicroStation' },
    { name: '实景建模', desc: 'ContextCapture' },
    { name: '点云建模', desc: 'Descartes' },
    { name: '桥梁分析', desc: 'RM Bridgge' },
    { name: '结构分析', desc: 'STAAD.Pro' },
    { name: '钢结构', desc: 'ProStructures' },
    { name: '建筑设计', desc: 'OpenBuildings' },
    { name: '人流模拟分析', desc: 'Legion' },
    { name: '工厂设计', desc: 'OpenPlant' },
    { name: '公路道路设计', desc: 'OpenRoads' },
    { name: '铁路线路设计', desc: 'OpenRail' },
    { name: '电气', desc: 'Substation' },
    { name: '岩土工程', desc: 'SoilVision' },
    { name: '施工4D模拟', desc: 'Synchro' },
    { name: '水利水文', desc: 'Openflows' },
  ];
  const BASJSX = BASList.map((item) => {
    return (
      <div key={item.name} className="group-item">
        <div>{item.name}</div>
        <div style={{ paddingTop: '4px' }}>{item.desc}</div>
      </div>
    );
  });

  let advantageList: Array<any> = [
    {
      icon: require('../assets/images/roadbridge/jiaotonglingyu.png').default,
      text: '跨世纪二十多年来的开发专注于交通领域',
    },
    {
      icon: require('../assets/images/roadbridge/jiejuefangan.png').default,
      text: '现有软件提供了“1+X”BIM市政道桥专业从初级建模到中级应用的一整套解决方案',
    },
    {
      icon: require('../assets/images/roadbridge/jiuye.png').default,
      text: '存在施工单位、设计单位、教育单位等大量客户，方便学生以后的就业',
    },
    {
      icon: require('../assets/images/roadbridge/ruanjian.png').default,
      text: '软件相对简单，易学易用',
    },
    {
      icon: require('../assets/images/roadbridge/peizhi.png').default,
      text: '软件对于电脑配置要求不高，节约实验室建设成本',
    },
  ];
  const advantageJSX = advantageList.map((item) => {
    return (
      <div className="flex advantage-item">
        <div className="advantage-icon-bd">
          <img className="advantage-icon" src={item.icon} alt="" />
        </div>
        <div className="advantage-text">{item.text}</div>
      </div>
    );
  });
  const navTo = (path: string) => {
    history.push(path);
  };
  return (
    <div className="roadBridge-container">
      <div className={'road-banner'}>
        <div className={'road-banner-title'}>
          “1+X”建筑信息模型（BIM）中级市政道桥方向职业技能等级考试
        </div>
        <div className={'road-banner-desc'}>
          1+X证书是国家职业教育的一项基本制度，也是构建职教发展模式的一项制度创新。
        </div>
      </div>
      <div className={'banner-content'}>
        根据国务院2019年1月发布的《国家职业教育改革实施方案》，从2019年开始，在职业院校、应用型本科高校启动“学历证书+若干职业技能等级证书”制度试点（即1+X证书制度试点）工作，进一步发挥好学历证书作用，夯实学生可持续发展基础，鼓励职业院校学生在获得学历证书的同时，积极取得多类职业技能等级证书，拓展就业创业本领，缓解结构性就业矛盾。
      </div>
      <div className="road-bg">
        <div className={'road-title'}>解决方案</div>
        <div className="road-text">
          1+X市政道桥方向考试解决方案是由 Bentley教育版、跨世纪设计大师CivilStation
          Designer（简称CSD）、跨世纪建造大师CivilStation Construction（简称CSC）组成的。
        </div>
        <div className="road-text">
          Bentley教育版集成了Bentley公司最广泛应用的几十款软件，涵盖基础设施领域，包含建筑，路桥隧，水电，核电等各专业。
        </div>
        <div className="road-text">
          跨世纪设计大师和Bentley教育版在建模上互为补充，能快速建立路基、桥梁、隧道、交安以及地质等BIM模型，跨世纪建造大师基于设计大师创建的模型可以实现快速编码绑码，更快完成从建模到施工管理的流程。
        </div>
        <div className="road-text">
          该解决方案可以同时满足1+X市政道桥方向从初级建模到中级应用考试大纲的所有要求，功能更适合市政、道桥、轨道交通等专业的学科建设。
        </div>
      </div>
      <div className="road-title">产品组合</div>
      <div className="group-title"> 50多种 Bentley Academic SELECT软件组合</div>
      <div className="group-box flex wrap">{BASJSX}</div>
      <div className="group-title">跨世纪土木交通产品组合 </div>
      <div className="group-box group-box2">
        <div className="flex">
          <div className="group-icon-box group-item">
            <img
              className="group-icon"
              src={require('../assets/images/about/06.png').default}
              alt=""
            />
            <div>CSD</div>
          </div>
          <div className="group-item">
            <div>桥梁BIM设计</div> <div>路基BIM设计</div> <div>涵洞BIM设计</div>
          </div>
          <div className="group-item">
            <div>隧道BIM设计</div> <div>地质BIM设计</div> <div>交安BIM设计</div>
          </div>
        </div>
        <div className="flex">
          <div className="group-icon-box group-item">
            <img
              className="group-icon"
              src={require('../assets/images/about/07.png').default}
              alt=""
            />
            <div>CSC</div>
          </div>
          <div className="group-item">
            <div>进度管理</div> <div>成本管理</div> <div>设计管理</div>
          </div>
          <div className="group-item">
            <div>质量管理</div> <div>安全管理</div> <div>技术管理</div>
          </div>
        </div>
      </div>
      <div className="road-bg">
        <div className="road-title"> 方案优势</div>
        {advantageJSX}
      </div>
      <div className="road-title"> 软件介绍 </div>
      <video
        controls
        className="road-video"
        src="http://cdn.ksj.com.cn/website/video/1%2BXCSC.mp4"
      ></video>
      <div className="road-video-desc">教育版建造大师 CivilStation Construction</div>

      <div
        className="appItem flex"
        onClick={() => {
          navTo('/civilstationdesigner');
        }}
      >
        <img
          className="appItem-icon"
          src={require('../assets/images/about/06.png').default}
          alt="icon"
        />
        <div className="appItem-con">
          <div className="appItem-title">设计大师CivilStation Designer</div>
          <div className="flex" style={{ justifyContent: 'space-between' }}>
            <div className="appItem-desc">市政道桥、轨道交通BIM软件</div>
            <div>{'查看详情 >'}</div>
          </div>
        </div>
      </div>
      <div
        className="appItem flex"
        onClick={() => {
          navTo('/civilstationconstru');
        }}
      >
        <img
          className="appItem-icon"
          src={require('../assets/images/about/07.png').default}
          alt="icon"
        />

        <div className="appItem-con">
          <div className="appItem-title">建造大师CivilStation Construction</div>
          <div className="flex" style={{ justifyContent: 'space-between' }}>
            <div className="appItem-desc">施工实训平台</div>
            <div>{'查看详情 >'}</div>
          </div>
        </div>
      </div>

      <AppFooter></AppFooter>
    </div>
  );
};

export default MunicipalRoadBridge;
